import React, { Component } from 'react';
import HeaderDeng from './components/Header';
import AboutDeng from './components/About';
import SkillsDeng from './components/Skills';
import ExpDeng from './components/Experience';
import EduDeng from './components/Education';
import AwardsDeng from './components/Awards';
import PortfolioDeng from './components/Portfolio';
import ContactDeng from './components/Contact';
import FooterDeng from './components/Footer';
import './../css/App.css';

class App extends Component {

  

  render() {


    return (

      <div>
        <HeaderDeng />

        <div id="about" className="bg_color">
          <AboutDeng />
        </div>
        
        <div id="skills" className="skills_bg">
          <SkillsDeng />
        </div>

        <div id="experience" className="bg_color">
          <ExpDeng />
        </div>

        <div id="education" className="edu_bg">
          <EduDeng />
        </div>

        <div id="awards" className="bg_color">
          <AwardsDeng />
        </div>

        <div id="portfolio" className="prt_bg">
          <PortfolioDeng />
        </div>

        <div id="contact" className="bg_color">
          <ContactDeng />
        </div>

        <div>
          <FooterDeng />
        </div>
      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/guest/App.js